// Базовый пуш в dataLayer
const trackAnalyticsEvent = (eventName, params = {}) => {
  try {
    if (typeof window !== 'undefined') {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: eventName, ...params });
    }
  } catch {}
};

// Инициализация глобального слушателя 'analytics'
export const initAnalyticsListener = () => {
  if (typeof window === 'undefined' || window.__analyticsListenerInit) return;
  window.__analyticsListenerInit = true;

  window.addEventListener('analytics', (e) => {
    const { event, ...params } = e.detail || {};
    if (!event) return;
    trackAnalyticsEvent(event, params);
  });
};

// Cахар (чтобы не писать new CustomEvent везде)
export const sendEvent = (event, params = {}) => {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new CustomEvent('analytics', { detail: { event, ...params } }));
};

//Количество предупреждений о публичности документа
// export const trackDocIsPublicWarning = ({ doc_url = null } = {}) => {
//   trackAnalyticsEvent('doc_is_public_warning', { doc_url });
// };

// //Количество созданых карточек документов
// export const trackDocCreated = ({ doc_url = null } = {}) => {
//     trackAnalyticsEvent('doc_created', { doc_url });
//   };

// //Количество просмотров каждого документа (уникальных открытий за сессию)
// export const trackDocOpened = ({ doc_url = null } = {}) => {
//     trackAnalyticsEvent('doc_opened', { doc_url });
// };


// //Через event listener

// //Document Modified
// export const trackDocModified = ({ doc_id = null, doc_url = null } = {}) => {
//     trackAnalyticsEvent('doc_modified', { doc_id, doc_url });
// };

// export const trackDocAccessModified = ({ doc_id = null, doc_url = null } = {}) => {
//   trackAnalyticsEvent('doc_access_modified', { doc_id, doc_url });
// };


